/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CODE_HIGHLIGHT_DIRECTIVES } from "../index";
var ClrSyntaxHighlightModule = (function () {
    function ClrSyntaxHighlightModule() {
    }
    return ClrSyntaxHighlightModule;
}());
export { ClrSyntaxHighlightModule };
ClrSyntaxHighlightModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [CODE_HIGHLIGHT_DIRECTIVES],
                exports: [CODE_HIGHLIGHT_DIRECTIVES]
            },] },
];
/** @nocollapse */
ClrSyntaxHighlightModule.ctorParameters = function () { return []; };
//# sourceMappingURL=syntax-highlight.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/code/syntax-highlight/syntax-highlight.module.js
// module id = 149
// module chunks = 4